import styled from 'styled-components'

export const FormContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`
